import { z } from "zod";

export const dubPartnersPublicTokenResponseSchema = z.object({
    publicToken: z.string().nullable(),
});

export type DubPartnersPublicTokenResponse = z.infer<
    typeof dubPartnersPublicTokenResponseSchema
>;
